import _ from 'lodash';
import React, { Component } from 'react';

import {
  getSetting,
  updateSetting,
} from 'common/api/setting';
import WebPushSubscriptionsList from './WebPushSubscriptionsList';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const NOTIFICATION_TYPES = [
  { labelFn: () => 'Order', value: 'order_placed' },
  { labelFn: () => 'Backtest Run Failed', value: 'historic_run_failed' },
  { labelFn: () => 'Live Run Failed', value: 'live_run_failed' },
  { labelFn: () => 'Login Reminder', value: 'login_reminder', shouldShow:!ApplicationDomainUtility.isAlgoverse  }
];

const NOTIFICATION_HEADERS = [
  { label: 'Type', key: 'type' },
  { label: 'Application Notification', key: 'application_notification' },
  { label: 'Browser Notification', key: 'browser_notification' },
  { label: 'Call Notification', key: 'call_notification', shouldShow: !ApplicationDomainUtility.isAlgoverse }
];

const propTypes = {};
const defaultProps = {};


class NotificationSettings extends Component {
  constructor(props) {
    super(props);

    this.state = { setting: [] };
  }

  componentDidMount() {
    getSetting()
      .then((setting) => this.setState({ setting }));
  }

  onSettingToggle = (settingKey) => {
    const { setting } = this.state;

    updateSetting({ [settingKey]: !setting[settingKey] });

    this.setState({
      setting: {
        ...setting,
        [settingKey]: !setting[settingKey]
      }
    });
  }

  renderSettingCheckbox = (settingKey) => {
    const { setting } = this.state;

    const isSettingsKeyNotAllowed = _.includes(
      ['login_reminder_application_notification', 'login_reminder_browser_notification'],
      settingKey
    );
    
    // Find the header config for this settingKey
    const headerKey = settingKey.split('_').slice(-2).join('_');
    const header = NOTIFICATION_HEADERS.find(h => h.key === headerKey);

    if (header && header.shouldShow === false) return null;

    if (isSettingsKeyNotAllowed) return null;

    return (
      <div className="custom-checkbox text-center custom-switch">

        <input
          type="checkbox"
          className="custom-control-input"
          id={settingKey}
          checked={!!setting[settingKey]}
          onChange={() => this.onSettingToggle(settingKey)}
        />

        <label className="custom-control-label" htmlFor={settingKey} />
      </div>
    );
  }

  renderNotificationTypeSetting = (notificationType, isBrokerUser) => {
    const tableDataShouldShow = notificationType?.shouldShow === false;
    const isLoginReminderType = notificationType.value === 'login_reminder';
    if (
      (!isBrokerUser && isLoginReminderType) || tableDataShouldShow) return null;
    return (
      <tr key={notificationType.value} className="notification-type">
        <td>{notificationType.labelFn()}</td>
        <td>{this.renderSettingCheckbox(`${notificationType.value}_application_notification`)}</td>
        <td>{this.renderSettingCheckbox(`${notificationType.value}_browser_notification`)}</td>
        <td>{this.renderSettingCheckbox(`${notificationType.value}_call_notification`)}</td>
      </tr>
    );
  }

  renderNotificationTypeSettingHead = (notificationType) => {
    if (notificationType?.shouldShow === false) return null;
    return (
      <th key={notificationType.key} className={notificationType.key !== 'type' ? 'text-center' : ''}>
        {notificationType.label}
      </th>
    );
  }

  render() {
    const { currentUserBroker } = window;
    const isBrokerUser = !_.isEmpty(currentUserBroker);
    return (
      <>
        <div className="user-notification-settings card">
          <div className="table-responsive">
            <table className="table mb-0">
              <thead>
                <tr>
                  {NOTIFICATION_HEADERS.map((type) => this.renderNotificationTypeSettingHead(type, isBrokerUser))}
                </tr>
              </thead>
              <tbody className="">
                {NOTIFICATION_TYPES.map((type) => this.renderNotificationTypeSetting(type, isBrokerUser))}
              </tbody>
            </table>
          </div>
        </div>
        <WebPushSubscriptionsList />
      </>
    );
  }
}

NotificationSettings.propTypes = propTypes;
NotificationSettings.defaultProps = defaultProps;
export default NotificationSettings;
